import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { getIntDictOptions, getBoolDictOptions, DICT_TYPE } from '@/utils/dict';
import { dateFormatter } from '@/utils/formatTime';
import { MusicApi } from '@/api/ai/music';
import * as UserApi from '@/api/system/user';
import { AiMusicStatusEnum } from '@/views/aip/utils/constants';
import { onMounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
/** AI 音乐 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiMusicManager'
  },
  __name: 'index',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    // const { t } = useI18n() // 国际化
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      userId: undefined,
      title: undefined,
      status: undefined,
      generateMode: undefined,
      createTime: [],
      publicStatus: undefined
    });
    const queryFormRef = ref(); // 搜索的表单
    const userList = ref([]); // 用户列表
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await MusicApi.getMusicPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await MusicApi.deleteMusic(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 修改是否发布 */
    const handleUpdatePublicStatusChange = async row => {
      try {
        // 修改状态的二次确认
        const text = row.publicStatus ? '公开' : '私有';
        await message.confirm('确认要"' + text + '"该音乐吗?');
        // 发起修改状态
        await MusicApi.updateMusic({
          id: row.id,
          publicStatus: row.publicStatus
        });
        await getList();
      } catch {
        row.publicStatus = !row.publicStatus;
      }
    };
    /** 初始化 **/
    onMounted(async () => {
      getList();
      // 获得用户列表
      userList.value = await UserApi.getSimpleUserList();
    });
    return (_ctx, _cache) => {
      const _component_doc_alert = _resolveComponent("doc-alert");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_dict_tag = _resolveComponent("dict-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_doc_alert, {
        title: "AI 音乐创作",
        url: "https://doc.iocoder.cn/ai/music/"
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "-mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户编号",
            prop: "userId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.userId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.userId = $event),
              clearable: "",
              placeholder: "请输入用户编号",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "音乐名称",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.title = $event),
              placeholder: "请输入音乐名称",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "音乐状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.status = $event),
              placeholder: "请选择音乐状态",
              clearable: "",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).AI_MUSIC_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "生成模式",
            prop: "generateMode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.generateMode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => queryParams.generateMode = $event),
              placeholder: "请选择生成模式",
              clearable: "",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).AI_GENERATE_MODE), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "创建时间",
            prop: "createTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: queryParams.createTime,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => queryParams.createTime = $event),
              "value-format": "YYYY-MM-DD HH:mm:ss",
              type: "daterange",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "default-time": [new Date('1 00:00:00'), new Date('1 23:59:59')],
              class: "!w-240px"
            }, null, 8, ["modelValue", "default-time"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否发布",
            prop: "publicStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.publicStatus,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => queryParams.publicStatus = $event),
              placeholder: "请选择是否发布",
              clearable: "",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getBoolDictOptions)(_unref(DICT_TYPE).INFRA_BOOLEAN_STRING), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:search",
                class: "mr-5px"
              }), _cache[8] || (_cache[8] = _createTextVNode(" 搜索"))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: resetQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:refresh",
                class: "mr-5px"
              }), _cache[9] || (_cache[9] = _createTextVNode(" 重置"))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "编号",
            align: "center",
            prop: "id",
            width: "180",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "音乐名称",
            align: "center",
            prop: "title",
            width: "180px",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "用户",
            align: "center",
            prop: "userId",
            width: "180"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(userList.value.find(item => item.id === scope.row.userId)?.nickname), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "音乐状态",
            align: "center",
            prop: "status",
            width: "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).AI_MUSIC_STATUS,
              value: scope.row.status
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "模型",
            align: "center",
            prop: "model",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "内容",
            align: "center",
            width: "180"
          }, {
            default: _withCtx(({
              row
            }) => [row.audioUrl?.length > 0 ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              type: "primary",
              href: row.audioUrl,
              target: "_blank"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 音乐 ")])),
              _: 2
            }, 1032, ["href"])) : _createCommentVNode("", true), row.videoUrl?.length > 0 ? (_openBlock(), _createBlock(_component_el_link, {
              key: 1,
              type: "primary",
              href: row.videoUrl,
              target: "_blank",
              class: "!pl-5px"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" 视频 ")])),
              _: 2
            }, 1032, ["href"])) : _createCommentVNode("", true), row.imageUrl?.length > 0 ? (_openBlock(), _createBlock(_component_el_link, {
              key: 2,
              type: "primary",
              href: row.imageUrl,
              target: "_blank",
              class: "!pl-5px"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode(" 封面 ")])),
              _: 2
            }, 1032, ["href"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "时长（秒）",
            align: "center",
            prop: "duration",
            width: "100"
          }), _createVNode(_component_el_table_column, {
            label: "提示词",
            align: "center",
            prop: "prompt",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "歌词",
            align: "center",
            prop: "lyric",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "描述",
            align: "center",
            prop: "gptDescriptionPrompt",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "生成模式",
            align: "center",
            prop: "generateMode",
            width: "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).AI_GENERATE_MODE,
              value: scope.row.generateMode
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "风格标签",
            align: "center",
            prop: "tags",
            width: "180"
          }, {
            default: _withCtx(scope => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tags, tag => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: tag,
                round: "",
                class: "ml-2px"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(tag), 1)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "是否发布",
            align: "center",
            prop: "publicStatus"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row.publicStatus,
              "onUpdate:modelValue": $event => scope.row.publicStatus = $event,
              "active-value": true,
              "inactive-value": false,
              onChange: $event => handleUpdatePublicStatusChange(scope.row),
              disabled: scope.row.status !== _unref(AiMusicStatusEnum).SUCCESS
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "任务编号",
            align: "center",
            prop: "taskId",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "错误信息",
            align: "center",
            prop: "errorMessage"
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            align: "center",
            prop: "createTime",
            formatter: _unref(dateFormatter),
            width: "180px"
          }, null, 8, ["formatter"]), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            width: "100",
            fixed: "right"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:music:delete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[6] || (_cache[6] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[7] || (_cache[7] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      })], 64);
    };
  }
});